import { Link } from 'react-router-dom';
import styles from './About.module.css';

export default function About() {
  return (
    <div className={styles.about}>
      {/* Hero: logo y botones */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4° MasterClass EPI - Juntos Transformando Vidas"
                className={styles.logoImg}
              />
            </div>
          </div>
          <div className={styles.ctaButtons}>
            <Link to="/registro" className={styles.botonRegistro}>
              Registro
            </Link>
            <Link to="/login" className={styles.botonLogin}>
              Iniciar sesión
            </Link>
          </div>
        </div>
      </section>

      {/* Frase */}
      <section className={styles.tagline}>
        <div className={styles.fraseContent}>
          <img
            src={`${process.env.PUBLIC_URL}/frase.gif`}
            alt="Más de una década de evidencia, más de un siglo de innovación"
            className={styles.fraseImg}
          />
        </div>
      </section>
    </div>
  );
}
